import { createRoute, useEntityUrl } from 'framework/routing';
import { POSITION_FILL_REQUESTS_PATH } from './constants';

export const usePositionFillRequestsRoute = () => createRoute({ listRoute: POSITION_FILL_REQUESTS_PATH });

export const usePositionFillRequestsUrl = () => useEntityUrl({ baseLink: POSITION_FILL_REQUESTS_PATH });
